<template>
    <div class="saas-page profile-command-page">
        <div class="saas-hero card-saas profile-command-hero">
            <div class="saas-hero__main">
                <p class="saas-hero__crumb">
                    <router-link to="/user">{{ trans('user.user') }}</router-link>
                    <span class="px-1">/</span>
                    <span>{{ trans('auth.change_password') }}</span>
                </p>
                <h1 class="saas-hero__title">{{ userForm.first_name }} {{ userForm.last_name }}</h1>
                <p class="profile-command-hero__subtitle">{{ trans('auth.change_password') }}</p>
            </div>
        </div>

        <div class="nk-block">
            <div class="card-saas card-saas--flush admin-user-profile-card">
                <div class="card-aside-wrap">
                    <div class="card-content">
                        <user-sidebar menu="password" :id="id"></user-sidebar>
                        <div class="card-inner admin-user-form-inner">
                            <div class="nk-block">
                                <div class="nk-block-head admin-user-form-head">
                                    <h4 class="admin-user-section-title">{{trans('auth.change_password')}}</h4>
                                </div>
                                <form @submit.prevent="submit" @keydown="passwordForm.errors.clear($event.target.name)">
                                    <div class="row">
                                        <div class="col-12 form-group">
                                            <label for="">{{trans('auth.new_password')}}</label>
                                            <input type="password" name="new_password" class="form-control" :placeholder="trans('auth.new_password')" v-model="passwordForm.new_password">
                                            <show-error :form-name="passwordForm" prop-name="new_password"></show-error>
                                        </div>
                                        <div class="col-12 form-group">
                                            <label for="">{{trans('auth.new_password_confirmation')}}</label>
                                            <input class="form-control" type="password" value="" v-model="passwordForm.new_password_confirmation" name="new_password_confirmation" :placeholder="trans('auth.new_password_confirmation')">
                                            <show-error :form-name="passwordForm" prop-name="new_password_confirmation"></show-error>
                                        </div>
                                    </div>
                                    <div class="admin-user-form-actions">
                                        <button type="submit" class="btn btn-sm admin-toolbar-btn admin-toolbar-btn--solid">{{trans('auth.change_password')}}</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    <div class="card-aside card-aside-right user-aside toggle-slide toggle-slide-right toggle-break-xxl" data-content="userAside" data-toggle-screen="xxl" data-toggle-overlay="true" data-toggle-body="true">
                        <div class="card-inner-group" data-simplebar>
                            <user-summary :user="user"></user-summary>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>


<script>
    import userSidebar from './user-sidebar'
    import userSummary from './summary'

    export default {
        components : { userSidebar,userSummary },
        data() {
            return {
                id:this.$route.params.id,
                userForm: new Form({
                    first_name: '',
                    last_name: ''
                },false),
                passwordForm: new Form({
                    new_password: '',
                    new_password_confirmation: ''
                }),
                user: ''
            };
        },
        mounted(){
            if(this.id == helper.getAuthUser('id'))
                this.$router.push('/user');

            if(!helper.hasPermission('force-reset-user-password')){
                helper.notAccessibleMsg();
                this.$router.push('/home');
            }

            axios.get('/api/user/'+this.id)
                .then(response => response.data)
                .then(response => {
                    this.user = response.user;
                    this.userForm.first_name = response.user.profile.first_name;
                    this.userForm.last_name = response.user.profile.last_name;
                })
                .catch(error => {
                    helper.showDataErrorMsg(error);
                });
        },
        methods: {
            submit(){
                this.passwordForm.patch('/api/user/'+this.id+'/force-reset-password')
                    .then(response => {
                        toastr.success(response.message);
                    })
                    .catch(error => {
                        helper.showErrorMsg(error);
                    });
            },
            getConfig(config){
                return helper.getConfig(config);
            }
        }
    }
</script>

<style scoped>
.profile-command-page {
    --linear-accent: #625cf6;
    --linear-line: #e5e7eb;
    --linear-muted: #64748b;
}

.profile-command-hero,
.admin-user-profile-card {
    border-color: var(--linear-line);
    background: #ffffff;
}

.profile-command-hero__subtitle {
    margin: 0.25rem 0 0;
    color: var(--linear-muted);
    font-size: 0.8125rem;
    font-weight: 500;
}

.admin-user-form-inner {
    background: transparent;
}

.admin-user-section-title {
    color: #0f172a;
    font-weight: 600;
    letter-spacing: -0.02em;
}

.admin-user-form-actions {
    display: flex;
    justify-content: flex-end;
    margin-top: 0.5rem;
}
</style>
